import { Breadcrumbs, styled } from "@mui/material";
import { MiscSavio, StyleguideSavioColors, StyleguideSavioFonts } from "../../configuration/themeSettings";
import AppIconsHome from "../AppIcons/AppIconsHome";
import { Height } from "@mui/icons-material";

export const BreadcrumbsStyled = styled(Breadcrumbs, { label: "BreadcrumbsComponent-BreadcrumbsStyled" })(
    ({ theme }) => ({
        fontSize: 14,
        margin: 0 + " !important",
        borderBottom: "1px solid " + StyleguideSavioColors.lightGrey,
        paddingLeft: 10,
        paddingRight: 10,
        "> ol": {
            width: '100%',
            maxWidth: MiscSavio.maxWidthSite,
            margin: "0 auto",
            paddingLeft: 15,
            paddingRight: 15,
            flexWrap: 'nowrap',
            overflow: 'hidden',
            overflowX: 'auto',
            height: 29,
        },
        "li": {
            display: "flex",
            height: 26,
            alignItems: 'center',

            "&.MuiBreadcrumbs-separator": {
                color: StyleguideSavioColors.lightGrey,
                fontSize: 22,
            },

            "*": { fontSize: 12, color: StyleguideSavioColors.grayBreadcrumb + " !important", textAlign: 'left', whiteSpace: 'nowrap', },
            "a": {
                display: 'flex', alignItems: 'center', fontSize: 12, textDecoration: 'none',
                "&:hover": {
                    color: StyleguideSavioColors.blue + " !important",
                    textDecoration: 'underline !important'
                },

            },
            "p": {
                fontWeight: StyleguideSavioFonts.bold,
                color: StyleguideSavioColors.mainBlue + ' !important',
            }
        },

        '@media print': {
            display: 'none !important',
        }
    })
);


export const AppIconsHomeStyled = styled(AppIconsHome, { label: "BreadcrumbsComponent-AppIconsHomeStyled" })(
    ({ theme }) => ({
        fontSize: "15px",
    })
);
export const SubContainer = styled("div", { label: "BreadcrumbsComponent-SubContainer" })(
    ({ theme }) => ({
        width: '100%',
        maxWidth: MiscSavio.maxWidthSite,
        display: 'flex',
    })
);